import { DATA_SOURCES, isCovered } from '@/config/constants';
import DimensionIcon from 'components/DimensionIcon';
import { DimensionIconTag } from 'components/DataVis/RelatedHashtagsTable/styledComponents';
import { getHierarchy } from 'utils/hooks/useGetHierarchy';
import styled from 'styled-components';
import { tooltips } from '@/copy';

export const reduceIdsByType = (watchlist, dimensionType) =>
    (watchlist || []).reduce((acc, { id, type }) => {
        if (type !== dimensionType) return acc;
        if (!acc) return [id];
        acc.push(id);
        return acc;
    }, null);

export const reduceIdsWithSelectedFields = (
    watchlist,
    dimensionType,
    filterFn = () => true,
    fields = [],
) =>
    (watchlist || []).reduce((acc, curr) => {
        const { type, categoryId, brandId } = curr;
        if (type !== dimensionType || !filterFn({ type, categoryId, brandId }))
            return acc;
        const temp = {};
        fields.forEach((field) => {
            if (curr[field]) temp[field] = curr[field];
        });
        if (fields.length === Object.keys(temp).length) acc.push(temp);
        return acc;
    }, []);

export const getTooltipContent = (row) => {
    const { type, brand } = row;
    let title = '',
        body = '',
        dimensionType = type;

    if (type === 'hashtag') {
        title = brand ? tooltips.brandHashtags.title : tooltips.hashtags.title;
        body = brand ? tooltips.brandHashtags.body : tooltips.hashtags.body;
        dimensionType = 'hashtag';
    } else if (type === 'related-hashtag') {
        title = tooltips.relatedHashtags.title;
        body = tooltips.relatedHashtags.body;
        dimensionType = 'hashtag';
    } else if (type === 'related-category') {
        title = tooltips.popularityIndexRelatedEntities.title;
        body = tooltips.popularityIndexRelatedEntities.body;
        dimensionType = 'related-category';
    } else if (type === 'affinity') {
        title = brand
            ? tooltips.brandAffinitiesTitleHelp.title
            : tooltips.affinitiesTitleHelp.title;
        body = brand
            ? tooltips.brandAffinitiesTitleHelp.body
            : tooltips.affinitiesTitleHelp.body;
        dimensionType = 'affinity';
    } else if (type === 'instagram-hashtag') {
        title = brand
            ? tooltips.instagramBrandHashtags.title
            : tooltips.hashtagsInstagram.title;
        body = brand
            ? tooltips.instagramBrandHashtags.body
            : tooltips.hashtagsInstagram.body;
        dimensionType = 'hashtag';
    } else if (type === 'instagram-related-hashtag') {
        title = tooltips.instagramRelatedHashtags.title;
        body = tooltips.instagramRelatedHashtags.body;
        dimensionType = 'hashtag';
    }

    return (
        <div>
            <DimensionIconTag css="color: white;">
                <DimensionIcon dimensionType={dimensionType} />
                <span css="font-size: .875em;">{title}</span>
            </DimensionIconTag>
            <div
                css={`
                    margin-top: 0.75rem;
                    font-size: 0.875rem;
                `}
            >
                {body}
            </div>
        </div>
    );
};

export const isDataSupported = (item, country, dataSource) => {
    if (!country) return true;
    const { hierarchy_hint } = getHierarchy(item.hierarchies);
    if (!hierarchy_hint?.cat1) return true;
    return isCovered({
        geo: country?.text_id,
        dataSource,
        cat1: hierarchy_hint.cat1,
    });
};

export const Message = styled.div`
    color: ${({ theme }) => theme.gray_2};
    font-weight: 500;
    min-height: 4.125rem;
    display: flex;
    justify-content: center;
    align-items: center;
`;
